// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-form .basic-single {
  width: 100%;
}
.user-form .select__indicators,
.user-form .select__value-container.select__value-container--is-multi {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 50px !important;
}
.user-form .select__menu {
  position: absolute;
  top: 45px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CreateUserForm/CreateUserForm.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAEI;;EAEE,yBAAA;EACA,4BAAA;EACA,uBAAA;AAAN;AAGI;EACE,kBAAA;EACA,oBAAA;AADN","sourcesContent":[".user-form {\n    .basic-single {\n        width: 100%;\n    }\n    .select__indicators,\n    .select__value-container.select__value-container--is-multi {\n      padding-top: 0 !important;\n      padding-bottom: 0 !important;\n      height: 50px !important;\n    }\n  \n    .select__menu {\n      position: absolute;\n      top: 45px !important;\n    }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
